function DashboardCtrl($auth,$rootScope) {
  "ngInject";

const vm = this;
  vm.user = $auth.user;
}

export default {
  name: 'DashboardCtrl',
  fn: DashboardCtrl
};
